// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlueButtonBackToTop {
    position: absolute;
    top: 15em;
    right: 10em;
    z-index: 33;
    height: 5em;
    width: 5em;
    text-decoration: none;
    background-color: var(--DarkBlue);
    border: 1px solid var(--GrayBlue);
    border-radius: 50%;
    color: var(--BlueButtonComponentTextColor);
    font-size: 10px;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    outline: none;
    -webkit-tap-highlight-color: transparent;
}

.BlueButtonBackToTopLeft {
    position: absolute;
    top: 15em;
    left: 10em;
    z-index: 33;
    height: 5em;
    width: 5em;
    text-decoration: none;
    background-color: var(--DarkBlue);
    border: 1px solid var(--GrayBlue);
    border-radius: 50%;
    color: var(--BlueButtonComponentTextColor);
    font-size: 10px;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    outline: none;
    -webkit-tap-highlight-color: transparent;
}

.BlueButtonBackToTopArrow {
    width: 1em;
    filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(136deg)
        brightness(118%) contrast(119%);
}

@media only screen and (max-width: 878px) {
    .BlueButtonBackToTop {
        top: 18em;
        right: 2em;
        font-size: 8px;
    }

    .BlueButtonBackToTopLeft {
        top: 18em;
        left: 2em;
        font-size: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/BlueScrollBackToTopButton/BlueButtonBackToTop.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,iCAAiC;IACjC,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;IAC/C,eAAe;IACf,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,iCAAiC;IACjC,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;IAC/C,eAAe;IACf,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV;uCACmC;AACvC;;AAEA;IACI;QACI,SAAS;QACT,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,SAAS;QACT,cAAc;IAClB;AACJ","sourcesContent":[".BlueButtonBackToTop {\n    position: absolute;\n    top: 15em;\n    right: 10em;\n    z-index: 33;\n    height: 5em;\n    width: 5em;\n    text-decoration: none;\n    background-color: var(--DarkBlue);\n    border: 1px solid var(--GrayBlue);\n    border-radius: 50%;\n    color: var(--BlueButtonComponentTextColor);\n    font-size: 10px;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    cursor: pointer;\n    outline: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.BlueButtonBackToTopLeft {\n    position: absolute;\n    top: 15em;\n    left: 10em;\n    z-index: 33;\n    height: 5em;\n    width: 5em;\n    text-decoration: none;\n    background-color: var(--DarkBlue);\n    border: 1px solid var(--GrayBlue);\n    border-radius: 50%;\n    color: var(--BlueButtonComponentTextColor);\n    font-size: 10px;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    cursor: pointer;\n    outline: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.BlueButtonBackToTopArrow {\n    width: 1em;\n    filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(136deg)\n        brightness(118%) contrast(119%);\n}\n\n@media only screen and (max-width: 878px) {\n    .BlueButtonBackToTop {\n        top: 18em;\n        right: 2em;\n        font-size: 8px;\n    }\n\n    .BlueButtonBackToTopLeft {\n        top: 18em;\n        left: 2em;\n        font-size: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
